<template lang="html">
  <div class="page-summary">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageSummary'
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-summary
  padding: $gap-medium

  @include media($media-gt-medium)
    position: sticky
    top: 93px
    display: flex
    flex-direction: column

    h1
      margin: 0
      font-size: 16px

    .btn
      display: inline-block
</style>
